import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastType } from '../components/toast/toast.component';

export interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<ToastMessage[]>([]);
  public toasts$ = this.toastsSubject.asObservable();

  showSuccess(message: string, duration: number = 5000) {
    this.addToast(message, 'success', duration);
  }

  showError(message: string, duration: number = 5000) {
    this.addToast(message, 'error', duration);
  }

  showWarning(message: string, duration: number = 5000) {
    this.addToast(message, 'warning', duration);
  }

  showInfo(message: string, duration: number = 5000) {
    this.addToast(message, 'info', duration);
  }

  private addToast(message: string, type: ToastType, duration: number) {
    const id = this.generateId();
    const toast: ToastMessage = { id, message, type, duration };
    
    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([...currentToasts, toast]);

    if (duration > 0) {
      setTimeout(() => {
        this.removeToast(id);
      }, duration);
    }
  }

  removeToast(id: string) {
    const currentToasts = this.toastsSubject.value;
    const filteredToasts = currentToasts.filter(toast => toast.id !== id);
    this.toastsSubject.next(filteredToasts);
  }

  clearAll() {
    this.toastsSubject.next([]);
  }

  private generateId(): string {
    return 'toast_' + Math.random().toString(36).substr(2, 9);
  }
}